import { Component, Input } from '@angular/core';

interface AlertOptions {
  warning: string;
  error: string;
  success: string;
  info: string;
  [key: string]: string;
}

@Component({
    selector: 'bn-alert',
    templateUrl: './bn-alert.component.html'
})
export class BnAlertComponent {
    @Input() title = '';
    @Input() modifier = 'error';
    @Input() dismissible = false;

    public alertTypeMapping: AlertOptions = {
        warning: 'warning',
        error: 'warning',
        success: 'success',
        info: 'info',
    };

}
